<template>
    <div id="supplier_specialist">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">

            <modal-stationery v-show="modalStationery" v-if="modalStationery" :supplier_id="rowID" :role_id="role_id"
                :folder_id="4" />

            <modal-notes v-show="modalNotes" v-if="modalNotes" :user_id="user_id" :role_id="4" :supplier_id="rowID" />

            <modal-services-supplier v-if="modalServices" :role_id="4" :supplier_id="rowID" />

            <form v-show="modalForm" id="formEsp" class="animated fadeIn formEsp">
                <div v-if="modificar">
                    <input type="hidden" name="currentName" v-model="supplier.currentName">
                    <input type="hidden" name="currentEmail" v-model="supplier.currentEmail">
                    <input type="hidden" name="currentUserName" v-model="supplier.currentUserName">
                    <input type="hidden" name="currentPicture" v-model="supplier.currentPicture">
                    <input type="hidden" name="currentEspecialidad" v-model="supplier.currentEspecialidad">
                    <input type="hidden" name="currentSub_especialidad" v-model="supplier.currentSub_especialidad">
                    <input type="hidden" name="specialist_id" :value="supplier.id">
                    <span v-if="role_id === 7">
                        <input type="hidden" name="institution_id" :value="user_id">
                    </span>
                </div>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <div id="fotoUsuarioAdmin">
                            <img v-if="supplier.picture" :src="'../storage/especialistas/' + supplier.picture" alt="">
                            <img v-else :src="'../images/foto-usuario.jpg'" class="rounded-circle" alt="">
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                        <div class="fotoUploader">
                            <span class="btn btn-file">
                                Imagen <br> <i class="fas fa-upload"></i> <input type="file" data-label="avatar"
                                    name="picture" v-on:change="getLogo" placeholder="avatar">
                            </span>
                            <span class="label-file-papeleria alert alert-info picture"></span>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <p class="fotoUploader">
                            Imagen o Logotipo, las imágenes serán escaladas a un tamaño de 300 &times; 300 px, en
                            formato y peso permitido de carga es: <br> <strong>.jpeg, .png, .jpg, .gif, .svg, con un
                                peso maximo de 3mb</strong>
                        </p>
                        <cite>
                            El correo asignado en este formulario se usará para iniciar sesión en el sistema.
                        </cite>
                    </div>
                </div>
                <div class="row justify-content-center">

                    <div class="col-12">
                        <cite>*Campos requeridos con linea roja.</cite>
                        <h2 class="cabeza">Datos Generales</h2>
                    </div>

                    <div class="col-12 col-md-3">
                        <select v-model="supplier.tipo_per" id="tipoPer" v-on:change="changeInput(supplier.tipo_per)"
                            class="required" data-select="on" data-name-input="Tipo de Persona" name="tipo_per">
                            <option :value="0">Selecciona un tipo de persona</option>
                            <option :value="1">Física</option>
                            <option :value="2">Moral</option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">

                        <select data-select="on" v-model="supplier.isr" name="isr" id="isr" class="required">
                            <option :value="0">Selecciona un Porcentaje*</option>
                            <option value="0.01">1%</option>
                            <option value="0.0125">1.25%</option>
                            <option value="0.0150">1.50%</option>
                            <option value="0.0175">1.75%</option>
                            <option value="0.02">2%</option>
                            <option value="0.0225">2.25%</option>
                            <option value="0.08">8%</option>
                            <option value="0.10">10%</option>
                            <option value="0.10">10%</option>
                            <option value="0.16">16%</option>
                        </select>

                    </div>

                    <div class="col-12 col-md-3">
                        <input id="nom_com" v-model="supplier.nom_com" name="nom_com" type="text"
                            class="al-inputs scr-input" :class="{ required: person === true }"
                            placeholder="Nombre Comercial*" />
                        <label for="nom_com" class="scr-supertext">Nombre Comercial*</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input id="honorarios" maxlength="10" v-model="supplier.honorarios" name="honorarios"
                            type="text" class="al-inputs scr-input" placeholder="Honorarios" />
                        <label for="honorarios" class="scr-supertext">Honorarios</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input type="text" name="razon_social" id="razon_social" class="al-inputs scr-input"
                            :class="{ required: person === false }" placeholder="Razon Social"
                            v-model="supplier.razon_social" />
                        <label for="razon_social" class="scr-supertext">Razon Social</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input type="text" name="codigo_sat" id="codigo_sat" class="al-inputs scr-input"
                            placeholder="Código de SAT" v-model="supplier.codigo_sat" />
                        <label for="razon_social" class="scr-supertext">Código de SAT</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input id="correo" v-model="supplier.correo" name="correo" type="email"
                            class="al-inputs scr-input" placeholder="Correo" required />
                        <label for="correo" class="scr-supertext">Correo</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input id="telefonos" v-model="supplier.telefonos" name="telefonos" type="tel"
                            class="al-inputs scr-input" placeholder="Telefono" required />
                        <label for="telefonos" class="scr-supertext">Telefono</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <input id="dir_com" v-model="supplier.dir_com" name="dir_com" type="text"
                            class="al-inputs scr-input" placeholder="Dirección Comercial" />
                        <label for="dir_com" class="scr-supertext">Dirección Comercial</label>
                    </div>

                    <div class="col-12 col-md-3">
                        <select id="estado" v-model="supplier.edo_com" v-on:change="selectCities($event, true)"
                            name="edo_com" data-select="on" class="required">
                            <option :value="0">Seleccione un Estado*</option>
                            <option v-for="state in states" :value="state.id" :key="state.id">
                                {{ state.estado }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <select data-select="on" v-model="supplier.cd_com" name="cd_com" id="ciudad" class="required">
                            <option :value="0">Selecciona un Ciudad*</option>
                            <option v-for="city in cities_com" :value="city.cities_id" :key="city.cities_id">
                                {{ city.ciudad }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-3">
                        <select name="status" id="status" data-select="on" class="required" v-model="supplier.status">
                            <option :value="0">Selecciona un status</option>
                            <option :value="1">Activo</option>
                            <option :value="2">Inactivo</option>
                        </select>
                    </div>

                    <div class="col-12 col-md-11">
                        <textarea id="comentarios" class="al-inputs scr-input" v-model="supplier.horarios"
                            name="horarios" placeholder="Horarios" required />
                        <label for="comentarios" class="scr-supertext">Horarios</label>
                    </div>

                    <div class="col-12 col-sm-6">
                        <h2 class="cabeza">Servicios</h2>
                        <ul class="row ml-2">
                            <li class="col-6" v-for="service in services">
                                <input type="checkbox" :name="'selectedServices[]'" :value="service.service_id"
                                    v-model="selectedServices">
                                {{ service.services.servicio }}
                            </li>
                        </ul>
                    </div>

                    <div class="col-12 col-sm-6">
                        <h2 class="cabeza">Especialidades</h2>
                        <div class="row justify-content-center">
                            <div class="col-12 col-md-6">
                                <select id="especialidad" v-model="supplier.especialidad" name="especialidad"
                                    data-select="on" class="required" v-on:change="gynecology($event)">
                                    <option :value="0">Selecciona una especialidad</option>
                                    <option v-for="specialty in specialties" :value="specialty.id" :key="specialty.id">
                                        {{ specialty.especialidad }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-12 col-md-6">
                                <select id="sub_especialidad" v-model="supplier.sub_especialidad"
                                    name="sub_especialidad" data-select="on" v-on:change="gynecology($event)">
                                    <option :value="0">Selecciona una especialidad</option>
                                    <option v-for="specialty in specialties" :value="specialty.id" :key="specialty.id">
                                        {{ specialty.especialidad }}
                                    </option>
                                </select>
                            </div>
                            <div v-if="showTmp" class="col-12 col-md-12">
                                <br />
                                <input type="checkbox" name="t_m_p" v-model="supplier.t_m_p" value="1" id="">
                                Toma de Muestra Papanicolau
                            </div>
                            <div v-if="showElectrocardiogram" class="col-12 col-md-12">
                                <br />
                                <input type="checkbox" name="electrocardiogram_enabled"
                                    v-model="supplier.electrocardiogram_enabled" value="1" id="">
                                Electrocardiograma Habilitado
                                <div v-if="supplier.electrocardiogram_enabled">
                                    <br>
                                    <div class="row">
                                        <div class="col-12 col-sm-6">
                                            <input style="margin-top:0" placeholder="Electrocardiograma en reposo"
                                                class="float al-inputs" type="text" name="honorarios_electrocardiograma"
                                                v-model="supplier.honorarios_electrocardiograma" id="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-12">
                                <br />
                                <input style="margin-top:3px" class="float" type="checkbox" name="s_r_h"
                                    v-model="supplier.s_r_h" value="1" id="">
                                <span class="float">Se habilitan las sesiones</span>
                                <div v-if="supplier.s_r_h">
                                    <hr>
                                    <h5 style="margin-bottom:0;">Costos:</h5>
                                    <div class="row">

                                        <div class="col-12 col-sm-6">
                                            <input style="margin-top:0" placeholder="Sesión" class="float al-inputs"
                                                type="text" name="honorarios_sesiones"
                                                v-model="supplier.honorarios_sesiones" id="">
                                        </div>
                                        <div class="col-12 col-sm-6">

                                            <input style="margin-top:0" placeholder="Reducción" class="float al-inputs"
                                                type="text" name="honorarios_reduccion"
                                                v-model="supplier.honorarios_reduccion" id="">

                                        </div>
                                        <div class="col-12 col-sm-6">

                                            <input style="margin-top:0" placeholder="Padecimiento"
                                                class="float al-inputs" type="text" name="honorarios_padecimiento"
                                                v-model="supplier.honorarios_padecimiento" id="">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <h2 class="cabeza">Datos de Autenticación</h2>
                <div class="row justify-content-center">
                    <div class="col-12 col-md-3">
                        <input id="pass" v-model="supplier.username" name="username" type="text"
                            class="al-inputs scr-input" placeholder="Usuario" />
                        <label for="pass" class="scr-supertext">Usuario</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input id="password" v-model="supplier.password" type="password" name="password"
                            class="al-inputs scr-input" :class="{ required: !modificar }" placeholder="Password"
                            value="" />
                        <label for="password" class="scr-supertext">Password</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <button id="dyn-button" type="button" class="btn btn-primary" v-on:click="guardar()">Guardar

                        </button>
                    </div>
                </div>
            </form>

        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                v-model="pagination.current_page" :total-rows="pagination.total"
                                :per-page="pagination.per_page" aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-2 mb-3 mb-sm-0">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">{{
                                tituloBtn
                                }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">

                        <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy"
                            :items="pagination.data" :filter="filter">
                            <template #head(Acciones)="{ item }">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #cell(Proveedor)="data">
                                {{ data.item.nom_com }}
                            </template>
                            <template #cell(E-mail)="{ item }">
                                <span v-if="item.reluser">
                                    {{ item.reluser.email }}
                                </span>
                            </template>
                            <template #cell(Estado)="{ item }">
                                <span v-if="item.reledo">
                                    {{ item.reledo.estado }}
                                </span>
                            </template>
                            <template #cell(Ciudad)="{ item }">
                                <span v-if="item.relcity">
                                    {{ item.relcity.ciudad }}
                                </span>
                            </template>
                            <template #cell(Acciones)="{ item }">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a v-if="role_id === 1" class="dropdown-item" href="javascript:void(0)"
                                            v-on:click="modificar = true; updateReg(item)">Editar</a>
                                        <a v-if="role_id === 1" class="dropdown-item" href="javascript:void(0)"
                                            v-on:click="rowID = item.id; openModalsProviders('stationery')">Subir
                                            Papelería</a>
                                        <a v-if="role_id === 1" class="dropdown-item" href="javascript:void(0)"
                                            v-on:click="rowID = item.id; openModalsProviders('note')">Agregar Nota</a>
                                        <a v-if="role_id === 1" class="dropdown-item" href="javascript:void(0)"
                                            v-on:click="rowID = item.id; openModalsProviders('services')">Agregar
                                            Servicio</a>
                                        <a v-if="role_id === 1" class="dropdown-item" href="javascript:void(0)"
                                            v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col-xl-2">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                v-model="pagination.current_page" :total-rows="pagination.total"
                                :per-page="pagination.per_page" aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { myMixins } from "../mixins/myMixins";
import { estadoService } from "../../Services/States.service";
import { statescitiesService } from "../../Services/Statescities.service";
import { supplierspecialistService } from "../../Services/SupplierSpecialist.service";
import { specialtysService } from "../../Services/Specialtys.service";
import { supplierinstitutionsService } from "../../Services/SupplierInstitutions.service";
import { getFormData } from "../../Utils/getDataForm";
import { servicesService } from "../../Services/Services.service";

export default {
    name: "supplier_specialist",
    mixins: [myMixins],
    props: {
        user_id: {
            type: Number,
            default: 0
        },
        role_id: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            splitColumn: 0,
            show: false,
            isBusy: false,
            modificar: false,
            filter: null,
            showTmp: false,
            showElectrocardiogram: false,
            //showSrh: false,
            supplier: {
                id: 0,
                codigo_sat: '',
                tipo_per: 0,
                nom_com: '',
                correo: '',
                telefonos: '',
                honorarios: '',
                isr: 0,
                razon_social: '',
                horarios: '',
                edo_com: 0,
                cd_com: 0,
                status: 0,
                t_m_p: 0,
                s_r_h: 0,
                electrocardiogram_enabled: 0,
                honorarios_sesiones: '',
                honorarios_reduccion: '',
                honorarios_padecimiento: '',
                honorarios_electrocardiograma: '',
                institution_id: 0,
                especialidad: 0,
                sub_especialidad: 0,
                username: '',
                password: '',
                currentName: '',
                currentEmail: '',
                currentUserName: '',
                currentEspecialidad: '',
                currentSub_especialidad: '',
                reduccion: '',
                padecimiento: '',
            },
            params: {
                limit: 10,
                page: 1,
            },
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            fields: [
                {
                    key: 'Proveedor',
                    sortable: false
                },
                {
                    key: 'E-mail',
                    sortable: false
                },
                {
                    key: 'Estado',
                    sortable: false
                },
                {
                    key: 'Ciudad',
                    sortable: false
                },
                {
                    key: 'Acciones',
                    sortable: false
                }
            ],
            states: [],
            cities_fiscal: [],
            cities_com: [],
            specialties: [],
            institutions: [],
            selectedServices: [],
            services: [],
            tituloBtn: 'Agregar',
            rowID: 0,
            person: false,
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await supplierspecialistService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formEsp');
            if (respVal) {
                this.disableSubmitBtn(true);
                const formData = getFormData('formEsp');
                if (this.modificar) {
                    resp = await supplierspecialistService.updateOne(this.supplier.id, formData, {
                        isForm: true,
                        onUploadProgress: this.onUploadProgress
                    });
                } else {
                    resp = await supplierspecialistService.saveOne(formData, {
                        isForm: true,
                        onUploadProgress: this.onUploadProgress
                    });
                }
                this.modificar = false;
                this.showModal = false;
                this.setEmpty();
                this.getAlert(resp.process);
                await this.index();
                //this.disableSubmitBtn(false);
            }
        },
        async index() {
            this.isBusy = true;
            switch (this.role_id) {
                case 1:
                    //SI ES UN ADMINISTRADOR
                    this.splitColumn = 6;
                    break;
                case 7:
                    console.log('user_id', this.user_id);
                    //SI ES UN PROVEEDOR
                    this.params = {
                        where: [{
                            field: 'institution_id',
                            operator: '=',
                            value: this.user_id,
                        }]
                    };
                    this.splitColumn = 12;
                    break;
            }
            this.pagination = await supplierspecialistService.getMany(this.params);
            this.states = await estadoService.getMany({ limit: 0 });
            this.specialties = await specialtysService.getMany({ limit: 0 });
            this.institutions = await supplierinstitutionsService.getMany({ limit: 0 });
            this.services = await servicesService.getServiceByEvent();
            this.isBusy = false;
        },
        async selectCities($e, kind_selected = false) {
            let state_id = this.stateId($e);
            switch (kind_selected) {
                case true:
                    this.cities_com = await statescitiesService.getCitiesByState(state_id);
                    break;
                default:
                    this.cities_fiscal = await statescitiesService.getCitiesByState(state_id);
                    break;
            }
        },
        gynecology($e) {
            let id = this.stateId($e);
            console.log('ginecologia', id);

            // Verificar tanto especialidad como subespecialidad
            let especialidadId = Number(this.supplier.especialidad);
            let subEspecialidadId = Number(this.supplier.sub_especialidad);

            // Inicializar variables
            this.showTmp = false;
            this.showElectrocardiogram = false;

            // Mostrar Papanicolau si alguna de las especialidades es 25 o 26
            if (especialidadId === 25 || especialidadId === 26 || subEspecialidadId === 25 || subEspecialidadId === 26) {
                this.showTmp = true;
            }

            // Mostrar Electrocardiograma si alguna de las especialidades es 7
            if (especialidadId === 7 || subEspecialidadId === 7) {
                this.showElectrocardiogram = true;
            }
        },
        updateReg(data = {}) {
            //console.log('data', data);
            this.selectedServices = [];
            if (this.modificar) {
                //console.info('actualizando el registro', data.s_r_h);
                this.selectCities(data.edo_com, true);
                this.tituloBtn = 'Actualizar';
                this.supplier = data;
                this.showTmp = data.t_m_p;
                this.showSrh = true;
                this.supplier.institution_id = (data.relspecialistinstitution != null) ? data.relspecialistinstitution.id : 0;
                this.supplier.ciudad = data.relcity.id;
                this.supplier.currentName = data.nom_com;
                this.supplier.currentEmail = data.reluser.email;
                this.supplier.correo = data.reluser.email;
                this.supplier.currentUserName = data.reluser.username;
                this.supplier.username = data.reluser.username;
                this.supplier.currentPicture = data.picture;
                if (data.relspecialistspecialty.length > 0) {
                    //console.log('actualizando el registro con especialidad y subespecialidad');
                    let especialidad = data.relspecialistspecialty.find(specialty => specialty.type_esp === 1);
                    let subEspecialidad = data.relspecialistspecialty.find(specialty => specialty.type_esp === 2);
                    this.supplier.especialidad = especialidad ? especialidad.specialty_id : null;
                    this.supplier.sub_especialidad = subEspecialidad ? subEspecialidad.specialty_id : null;
                    this.supplier.currentEspecialidad = especialidad ? especialidad.specialty_id : null;
                    this.supplier.currentSub_especialidad = subEspecialidad ? subEspecialidad.specialty_id : null;
                }
                if (data.relspecialistservices && data.relspecialistservices.length > 0) {
                    //console.log('actualizando el registro con servicios');
                    this.selectedServices = data.relspecialistservices.map(service => service.service_id);
                }
                this.openModalsProviders();
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        changeLimit() {
            this.index();
        },
        getLogo(event) {
            this.getNameFile(event, 'picture');
        },
        setEmpty() {
            this.supplier = {
                id: 0,
                codigo_sat: '',
                tipo_per: '',
                nom_com: '',
                correo: '',
                telefonos: '',
                honorarios: '',
                horarios: '',
                edo_com: 0,
                cd_com: 0,
                status: 0,
                t_m_p: 0,
                s_r_h: 0,
                electrocardiogram_enabled: 0,
                isr: 0,
                razon_social: 0,
                honorarios_sesiones: '',
                honorarios_reduccion: '',
                honorarios_padecimiento: '',
                honorarios_electrocardiograma: '',
                username: '',
                password: '',
                currentName: '',
                currentEmail: '',
                currentUserName: '',
                currentEspecialidad: '',
                currentSub_especialidad: '',
                person: false,
            }
        },
        changeInput(value) {
            console.log('changeInput- ', value)
            switch (value) {
                case 1:
                    this.person = true;
                    break;
                default:
                    this.person = false;
                    break;
            }
        },
    },
    mounted() {
        this.index();
    }
}
</script>
